// extracted by mini-css-extract-plugin
export default {"modules":"qvmHG","module":"J7vb2","moduleMenu":"XME6s"};